import { render, staticRenderFns } from "./SdmRS.vue?vue&type=template&id=afd9d320"
import script from "./SdmRS.vue?vue&type=script&lang=js"
export * from "./SdmRS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports